import React, { useState, createContext, useContext } from "react";
import useCookie from "../utils/useCookie";

export const defaultAppContext = {
    zoom: {
        current: 15,
        max: 20,
        min: 3.4,
        step: 0.045
    },
    index: 0,
    maxPanX: 4,
    sizeRatioDefault: 1,
    offset: { angle: 0, shift: 0 },
    defaultPageStep: 1,
    removePageModeToggle: true,
    autoStart: true,
    disableControlsForSinglePage: false,
    availableLocale: [
        { locale: 'en', label: 'English' },
        //    {locale: 'ru', label: 'Pусский'},
        //    {locale: 'de', label: 'Deutsch'},
        { locale: 'pl', label: 'Polski' },
        /*    {locale: 'cs', label: 'Čeština'},
            {locale: 'hu', label: 'Magyar'},
            {locale: 'pt-br', label: 'Português (BR)'},
            {locale: 'fr', label: 'Français'},
            {locale: 'es', label: 'Español'},
            {locale: 'es-mx', label: 'Español (MX)'},
            {locale: 'it', label: 'Italiano'},
            {locale: 'ja', label: '日本語'},
            {locale: 'ko', label: '한국어'},
            {locale: 'zh-cn', label: '简体中文'},
            {locale: 'zh-tw', label: '繁體中文'},
        */
    ],
    textures: {

    }
}
export const AppContext = createContext(defaultAppContext);

export const useAppContext = () => {
    const context = useContext(AppContext)
    if (context === undefined) {
        throw new Error('useAppState must be used within a AppContextProvider')
    }
    return context;
}

const useAppContextValue = () => {
    const context = useContext(AppContext)
    const [selection, setSelection] = useState(null)
    const [audio, setAudio] = useState(false)
    const [ambient, setAmbient] = useState(true)
    const [ready, setReady] = useState(false)
    const [started, setStarted] = useState(false)
    const [current, setCurrent] = useState(0)
    const [zoomDelta, setZoomDelta] = useState(null)
    const [allowZoomIn, setAllowZoomIn] = useState(false)
    const [allowZoomOut, setAllowZoomOut] = useState(false)
    const [playingVideo, setPlayingVideo] = useState(null)
    const [voiceOver, setVoiceOver] = useState(false)
    const [stickers, setStickers] = useState([])
    const [radio, setRadio] = useState(null)
    const [playRadio, setPlayRadio] = useState(true)
    const [playRadioIndex, setPlayRadioIndex] = useState(0)
    const [advancedMode, setAdvancedMode] = useState(true)
    const [modeSelection, setModeSelection] = useState(false)
    const [playVoiceOver, setPlayVoiceOver] = useState(false)
    const [pageStep, setPageStep] = useState(context.defaultPageStep)
    const [htmlOverlay, setHtmlOverlay] = useState(false)
    const [showStickersModal, setStickersModal] = useState(false)
    const [suspendedControls, setSuspendControls] = useState(false)
    const [tableOfContents, setTableOfContents] = useState(false)
    const [langSelection, setLangSelection] = useState(false)
    const [pages, setPages] = useState(null);
    const [pageTransition, setPageTransition] = useState(false);
    const [darkTransition, setDarkTransition] = useCookie('_dt_', "");
    const [autoStartPage, setAutoStartPage] = useCookie('_asp_', "");

    return {
        audio, setAudio,
        ambient, setAmbient,
        selection, setSelection,
        current, setCurrent,
        ready, setReady,
        started, setStarted,
        zoomDelta, setZoomDelta,
        playingVideo, setPlayingVideo,
        voiceOver, setVoiceOver,
        playVoiceOver, setPlayVoiceOver,
        stickers, setStickers,
        radio, setRadio,
        playRadio, setPlayRadio,
        playRadioIndex, setPlayRadioIndex,
        advancedMode, setAdvancedMode,
        modeSelection, setModeSelection,
        pageStep, setPageStep,
        htmlOverlay, setHtmlOverlay,
        allowZoomIn, setAllowZoomIn,
        allowZoomOut, setAllowZoomOut,
        showStickersModal, setStickersModal,
        suspendedControls, setSuspendControls,
        tableOfContents, setTableOfContents,
        langSelection, setLangSelection,
        pages, setPages,
        autoStartPage, setAutoStartPage,
        pageTransition, setPageTransition,
        darkTransition, setDarkTransition,
        ...context
    }
};

export const AppContextProvider = ({ children }) => {
    const value = useAppContextValue()

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};

